module.exports = __webpack_public_path__ + "img/AL281-2-EN.60370186.jpg";